import type { FC } from "react";

const WvYoutubeVideoPlayer: FC<{
  link: string;
  title?: string;
  className?: string;
}> = ({
  link,
  title = "Youtube Video Player",
  className = "component-video w-full h-full",
}) => (
  <iframe
    title={title}
    src={link}
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    allowFullScreen
    className={className}
  ></iframe>
);

export default WvYoutubeVideoPlayer;
